<template>
  <div class="app-container">
    <header class="app-header">
      <div class="logo">
        <img src="@/assets/logo.png" alt="Logo" class="logo-image" />
        <h1>WondaCRM</h1>
      </div>
      <div class="user-menu" v-if="isAuthenticated">
        <router-link to="/" class="nav-link">
          <i class="fas fa-comments"></i> Чаты
        </router-link>
        <router-link v-if="isAdmin" to="/statuses" class="admin-link">
          <i class="fas fa-tags"></i> Статусы
        </router-link>
        <router-link v-if="isAdmin" to="/users" class="admin-link">
          <i class="fas fa-users"></i> Пользователи
        </router-link>
        <router-link v-if="isAdmin" to="/dashboard" class="admin-link">
          <i class="fas fa-chart-line"></i> Аналитика
        </router-link>
        <span class="username">{{ user.name }}</span>
        <button @click="logout" class="logout-button">
          <i class="fas fa-sign-out-alt"></i> Выйти
        </button>
      </div>
    </header>
    
    <main class="app-content">
      <router-view />
    </main>
  </div>
</template>

<script>
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import socket, { connect, disconnect } from './plugins/socket';

export default {
  name: 'App',
  setup() {
    const store = useStore();
    const router = useRouter();
    const connectionAttempts = ref(0);
    const maxConnectionAttempts = 5;
    
    const isAuthenticated = computed(() => store.getters.isAuthenticated);
    const isAdmin = computed(() => store.getters.isAdmin);
    const user = computed(() => store.state.auth.user);
    
    const logout = () => {
      store.dispatch('logout');
      router.push('/login');
    };
    
    // Обработчик для уведомления об изменении списка чатов
    const handleChatsChanged = () => {
      // Запрашиваем обновление списка чатов через REST API
      store.dispatch('fetchChats');
    };
    
    const attemptConnection = () => {
      if (connectionAttempts.value >= maxConnectionAttempts) {
        console.error('Превышено максимальное количество попыток подключения к WebSocket');
        return;
      }
      
      console.log(`Попытка подключения к WebSocket ${connectionAttempts.value + 1}/${maxConnectionAttempts}`);
      connectionAttempts.value++;
      
      connect();
    };
    
    onMounted(() => {
      console.log('App: компонент смонтирован');
      
      // Если пользователь авторизован, подключаемся к WebSocket
      if (isAuthenticated.value) {
        console.log('Пользователь авторизован, подключаемся к WebSocket');
        attemptConnection();
      }
      
      // Подписываемся на уведомления об изменении списка чатов
      socket.on('chats_changed', handleChatsChanged);
      
      // Обработчик ошибки подключения
      socket.on('connect_error', (error) => {
        console.error('Ошибка подключения к WebSocket:', error);
        
        // Пытаемся переподключиться через 5 секунд
        setTimeout(() => {
          if (!socket.connected && isAuthenticated.value) {
            console.log('Попытка переподключения к WebSocket');
            attemptConnection();
          }
        }, 5000);
      });
    });
    
    onUnmounted(() => {
      console.log('App: компонент размонтирован');
      
      // Отписываемся от уведомлений об изменении списка чатов
      socket.off('chats_changed', handleChatsChanged);
      
      // Отключаемся от WebSocket
      disconnect();
    });
    
    return {
      isAuthenticated,
      isAdmin,
      user,
      logout
    };
  }
};
</script>

<style>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Roboto', Arial, sans-serif;
  font-size: 14px;
  line-height: 1.5;
  color: #333;
  background-color: #f5f5f5;
}

.app-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.app-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background-color: #2196f3;
  color: white;
}

.logo {
  display: flex;
  align-items: center;
}

.logo-image {
  height: 30px;
  margin-right: 10px;
}

.user-menu {
  display: flex;
  align-items: center;
}

.nav-link {
  margin-right: 20px;
  color: white;
  text-decoration: none;
  display: flex;
  align-items: center;
}

.nav-link i {
  margin-right: 5px;
}

.nav-link:hover {
  text-decoration: underline;
}

.router-link-active {
  font-weight: bold;
  text-decoration: underline;
}

.admin-link {
  margin-right: 20px;
  color: white;
  text-decoration: none;
  display: flex;
  align-items: center;
}

.admin-link i {
  margin-right: 5px;
}

.admin-link:hover {
  text-decoration: underline;
}

.username {
  margin-right: 15px;
}

.logout-button {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
}

.logout-button i {
  margin-right: 5px;
}

.logout-button:hover {
  text-decoration: underline;
}

.app-content {
  flex: 1;
  display: flex;
  overflow: hidden;
}
</style>
